import Breadcrumbs from "components/Common/Breadcrumb"
import Filters from "components/Common/Filters"
import Paginations from "components/Common/Paginations"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import formatDateTime from "components/Shared/formatDateTime"
import TableShimmer from "components/Shared/TableShimmer"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Badge, Card, CardBody, Col, Row, Table } from "reactstrap"
import { exportRequest } from "store/actions/commonAction"

const ExportRequests = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    loading,
    totalCount,
    totalPages,
    currentPage,
    itemsPerPage,
    exportRequests,
  } = useSelector(state => state.Common)

  const { userId, accountType } = useSelector(state => state.Login)

  useEffect(() => {
    getExportRequest()
  }, [])

  const updatedUserId = accountType === "superadmin" ? "" : userId

  const getExportRequest = () => {
    const payload = {
      perPage: 10,
      pageNo: 1,
      status: 0, //1. Scheduled, 2 Sent, 3.Email Error, 4. No records 5. Internal S E
      orderBy: 2,
      type: [],
      exportType: [],
      userId: updatedUserId,
      dateRange: {},
    }
    dispatch(exportRequest(payload))
  }

  const [selectedFilters, setSelectedFilters] = useState({
    status: 0,
    sortOrder: 1,
    type: [],
  })

  const filters = [
    {
      name: "status",
      type: "select",
      options: [
        { label: t("All"), value: 0 },
        { label: t("Scheduled"), value: 1 },
        { label: t("Sent"), value: 2 },
      ],
      placeholder: t("All"),
    },
    {
      name: "sortOrder",
      type: "select",
      options: [
        { label: t("Ascending"), value: 1 },
        { label: t("Descending"), value: 2 },
      ],
      placeholder: t("Ascending"),
    },
    {
      name: "type",
      type: "multiSelect",
      options: [
        { label: t("Customer"), value: "CUSTOMER" },
        { label: t("User Activity"), value: "USER-ACTIVITY" },
        { label: t("API Logs"), value: "API-LOGS" },
        { label: t("Loyalty Points"), value: "LOYALTY-POINTS" },
      ],
      placeholder: t("Select Type"),
    },
  ]

  const handleFilterChange = (selectedValue, filterName) => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }))
  }

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }

  const handleSearch = () => {
    const { status, sortOrder, type } = selectedFilters
    const updatedTypes = type?.map(item => item.value) || []

    const payload = {
      perPage: itemsPerPage,
      pageNo: 1,
      status: Number(status),
      orderBy: Number(sortOrder),
      type: updatedTypes,
      exportType: [],
      userId: updatedUserId,
      dateRange: {},
    }
    dispatch(exportRequest(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/export-requests?page=1`)
        }
      })
      .catch(error => {})
  }

  // useEffect(() => {
  //   handleSearch()
  // }, [selectedFilters])

  const onPageChange = page => {
    const { status, sortOrder, type } = selectedFilters
    const updatedTypes = type?.map(item => item.value) || []

    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      status: Number(status),
      orderBy: Number(sortOrder),
      type: updatedTypes,
      exportType: [],
      userId: updatedUserId,
      dateRange: {},
    }
    dispatch(exportRequest(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/export-requests?page=${page}`)
        }
      })
      .catch(error => {})
  }
  const handleReset = () => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: 1,
      status: 0,
      orderBy: 1,
      type: [],
      exportType: [],
      userId: updatedUserId,
      dateRange: {},
    }
    dispatch(exportRequest(payload))
    setSelectedFilters({
      status: 0,
      sortOrder: 1,
      type: [],
    })
  }
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <DataExportDropdown
                cardTitle={t("Export Requests List")}
                isAddBtn={false}
              />
              <CardBody>
                <Filters
                  filters={filters}
                  hideSearch={true}
                  handleSearchChange={handleSearchChange}
                  handleFilterChange={handleFilterChange}
                  handleSearch={handleSearch}
                  onReset={handleReset}
                  selectedFilters={selectedFilters}
                />

                <div className="">
                  {loading ? (
                    <TableShimmer row={7} col={5} />
                  ) : exportRequests.length === 0 ? (
                    <p className="text-center my-2">{t("No data found")}</p>
                  ) : (
                    <Table>
                      <thead className="table-light full_th">
                        <tr>
                          <th>{t("S. No.")}</th>
                          <th>{t("Name")}</th>
                          <th>{t("Type")}</th>
                          <th>{t("Export Type")}</th>
                          <th>{t("Status")}</th>
                          <th>{t("Created At")}</th>
                          <th>{t("Updated At")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {exportRequests.map(
                          (
                            {
                              _id,
                              userId,
                              type,
                              exportType,
                              createdAt,
                              updatedAt,
                              status,
                            },
                            index
                          ) => (
                            <tr key={_id}>
                              <td>{(currentPage - 1) * 10 + index + 1}</td>
                              <td>
                                {userId?.firstName} {userId?.lastName || "-"}
                              </td>
                              <td>{type}</td>
                              <td>{exportType}</td>
                              <td>
                                {status === 1 && (
                                  <Badge className="bg-warning p-1 fs-6">
                                    Scheduled
                                  </Badge>
                                )}
                                {status === 2 && (
                                  <Badge className="bg-success p-1 fs-6">
                                    Sent
                                  </Badge>
                                )}
                                {(status === 3 ||
                                  status === 4 ||
                                  status === 5) && (
                                  <Badge className="bg-danger p-1 fs-6">
                                    Error
                                  </Badge>
                                )}
                              </td>
                              <td>{formatDateTime(createdAt)}</td>
                              <td>{formatDateTime(updatedAt)}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                  )}
                </div>
                {!loading && exportRequests.length > 0 && (
                  <div className="mt-3">
                    <Paginations
                      data={exportRequests}
                      itemsPerPage={itemsPerPage}
                      onPageChange={onPageChange}
                      currentPage={currentPage}
                      totalPages={totalPages}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default ExportRequests
